import { Programs } from '../constants';

/**
 * Single source of truth for program availability and policy.
 */
export const getProgramPolicy = () => {
    const satEnabled = import.meta.env.VITE_SAT_ENABLED === "true";
    const allowed = satEnabled
        ? [Programs.ISEE, Programs.SAT, Programs.VOCAB_MASTERY]
        : [Programs.ISEE, Programs.VOCAB_MASTERY];

    return {
        satEnabled,
        allowed,
        isAllowed: (programId) => allowed.includes(programId),
    };
};
